import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGridComponent from 'modules/ui/editform/subForm/EditFormGridComponent';
import { useParams, withRouter } from 'react-router';
import FieldType from 'app/admin/dataset/dto/FieldType';
import FitterLogEditService from '../service/FitterLogEditService';

const config = data => {
	return {
		key: 'fitterLogEditForm',
		topic: 'fitterLog',
		service: FitterLogEditService,
		tabList: initData => {
			return [{ key: 'basic' }, { key: 'fields' }];
		},
		fields: initData => {
			const fields = [
				{
					key: 'name',
					component: EditFormTextField,
					required: true,
					readOnly: data.id !== 'new'
				},
				{
					key: 'table_name',
					component: EditFormTextField,
					required: true
				},
				{
					key: 'description',
					component: EditFormTextField,
					multiline: true
				},
				{
					key: 'fields',
					tab: 'fields',
					component: EditFormGridComponent,
					defaultValue: {
						id: null,
						name: null,
						role: null,
						type: null
					},
					fields: [
						{
							key: 'name',
							component: EditFormTextField,
							required: true
						},
						{
							key: 'type',
							component: EditFormSelectField,
							required: true,
							type: 'enum',
							items: Object.keys(FieldType).map(key => {
								return { label: FieldType[key], value: key };
							})
						}
					]
				}
			];

			return fields;
		}
	};
};

function FitterLogEditForm() {
	const { id } = useParams();
	const dispatch = useDispatch();
	const myConfig = config({ id });
	return (
		<EditFormPage
			config={myConfig}
		// onSave={result => {
		// 	if (!result.engineSuccessful) dispatch(showMessage({ message: `Engine: ${result.engineMessage}` }));
		// }}
		/>
	);
}

export default withRouter(FitterLogEditForm);
